import { UTCDate } from '@date-fns/utc';
import { TransactionView } from '../../../types/entity-types';

type getLatestDebitTransferDateArgs = {
  transactions?: TransactionView[];
};

export const getLatestDebitTransferDate = ({ transactions }: getLatestDebitTransferDateArgs) => {
  if (!transactions || transactions.length === 0) {
    return undefined;
  }

  const filteredSortedTransactions = transactions
    .filter((t) => !t.isCredit)
    .sort((a, b) => new UTCDate(b.fspDate).getTime() - new UTCDate(a.fspDate).getTime());

  return filteredSortedTransactions[0]?.fspDate;
};
